import {
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  FormHelperText,
  Select,
  MenuItem,
  Stack,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import {
  DECIMAL_BOARD,
  ORDER_INPUT_TABLE_ROW,
  ORDER_WIZARD_ITEMS,
} from "../../../../shared/constants/constants";
import "./rateContractInputTable.scss";
import { useEffect, useState } from "react";
import store from "../../../../store/store";
import { getAllProductTypesApi } from "../../../../store/api/rfq";
import { getPartyProductType } from "../../../../store/api/party";
import { getUserContext } from "../../../../shared/utils/utils";
import { ITEM_STATUS } from "../../../../shared/constants/constants";
import { ReactComponent as DeleteCustom } from "../../../../shared/assets/deleteIcon.svg";
import BigNumber from "bignumber.js";
import { AddBoxOutlined } from "@mui/icons-material";

type PopupMessageTypes = {
  open: boolean;
  message: string;
};
interface ContractInputTableProps {
  orderHeaderData: any;
  setOrderHeadData: (data: any) => void;
  handleAddOrderRow: any;
  ITEM_UOMs: any;
  validationErrors: any;
  resetValidationErrors: (errorName: string) => void;
  setError: React.Dispatch<React.SetStateAction<PopupMessageTypes>>;
  products: any;
  adjustments: any[];
  setAdjustments: (data: any) => void;
}

const RateContractInputTable = ({
  orderHeaderData,
  setOrderHeadData,
  ITEM_UOMs,
  handleAddOrderRow,
  validationErrors,
  resetValidationErrors,
  setError,
  products,
  adjustments,
  setAdjustments,
}: ContractInputTableProps) => {
  const [productType, setProductType] = useState<any>([]);
  const [partyProductType, setPartyProductType] = useState<any>([]);
  const [itemUploadDialog, setItemUploadDialog] = useState(false);
  const [dialogIndex, setDialogIndex] = useState<null | number>(0);
  const [expandedItemId, setExpandedItemId] = useState<number | null>(null);
  const [commentDialog, setCommentDialog] = useState(false);
  const [commentDialogIndex, setCommentDialogIndex] = useState<null | number>(
    0
  );
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const userContext: any = getUserContext();
  const [activeItemNameIndex, setActiveItemNameIndex] = useState<null | number>(
    null
  );
  // const [openDiscounts, setOpenDiscounts] = useState<boolean>(false);
  // const [adjustmentValues, setAdjustmentValues] = useState({
  //   totalAdjustedAmount: 0,
  //   totalAdjustmentTax: 0,
  //   grandAdjustedAmount: 0,
  // });
  const orgPartyId = userContext?.orgPartyIds[0];

  useEffect(() => {
    //console.log("orderHeader data :: ", orderHeaderData);
    const dispatchers = async () => {
      await store
        .dispatch(getAllProductTypesApi())
        .unwrap()
        .then((res: any) => {
          setProductType(res.data);
        });

      await store
        .dispatch(getPartyProductType({ partyIds: [orgPartyId] }))
        .unwrap()
        .then((res) => {
          res.data.forEach((element: any) => {
            if (element.partyId === orgPartyId) {
              setPartyProductType([...element?.productTypeIds]);
            }
          });
        });
    };
    dispatchers();
  }, []);

  const onClose = () => {
    setDialogIndex(null);
    setItemUploadDialog(false);
  };

  const handleOpenActionsDialog = (index: number) => {
    setDialogIndex(index);
    setItemUploadDialog(true);
  };

  const onCommentClose = () => {
    setCommentDialogIndex(null);
    setCommentDialog(false);
  };

  const handleOpenCommentDialog = (index: number) => {
    setCommentDialogIndex(index);
    setCommentDialog(true);
  };

  const handleShowMore = (itemId: number) => {
    setExpandedItemId((prev) => {
      return prev === itemId ? null : itemId;
    });
  };

  const handleItemNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const value = event.target.value;
    handleInputChange(index, "productId", "", `productId_${index}`);

    if (value) {
      const filtered = products.filter((product: any) =>
        product.productName.toLowerCase().includes(value.toLowerCase())
      );

      setFilteredProducts(filtered);
    } else {
      setFilteredProducts([]);
    }

    handleInputChange(index, "item", value, `itemName_${index}`);
  };

  const handleSelectItem = (product: any, index: any) => {
    handleInputChange(index, "item", product?.productName, `item_${index}`);
    handleInputChange(index, "productId", product?._id, `productId_${index}`);
    handleInputChange(index, "hsnCode", product?.hsnCode, `hsnCode_${index}`);
    handleInputChange(
      index,
      "brandName",
      product?.brandName,
      `brandName_${index}`
    );
    handleInputChange(
      index,
      "itemTypeId",
      product?.productTypeId,
      `itemTypeId_${index}`
    );
    handleInputChange(index, "gst", product?.gst, `gst_${index}`);

    setActiveItemNameIndex(null);
  };

  const handleInputChange = (
    index: number,
    name: string,
    value: any,
    errorName: string
  ) => {
    resetValidationErrors("items_div");
    resetValidationErrors(errorName);

    setOrderHeadData((prevData: any) => {
      const updatedItems = [...prevData.items];
      const currentItem = updatedItems[index];
      // let totalAmount = parseFloat(
      //   Number(prevData.totalAmount ?? 0).toFixed(2)
      // );
      // let totalTaxAmount = parseFloat(
      //   Number(prevData.totalTaxAmount ?? 0).toFixed(2)
      // );
      // let grandTotal = parseFloat(Number(prevData.grandTotal ?? 0).toFixed(2));

      const removeOldItemValues = () => {
        const itemAmountNum = Number(currentItem.amount ?? 0);
        const itemTaxAmountNum =
          (currentItem.pricePerUnit ?? 0) *
          (Number(currentItem.quantity) ?? 0) *
          (currentItem.gst ?? 0) *
          0.01;
        // totalAmount -= parseFloat(itemAmountNum.toFixed(2));
        // totalTaxAmount -= parseFloat(itemTaxAmountNum.toFixed(2));
      };

      const recalculateAndUpdateItem = (updatedField: any) => {
        const priceSplit = updatedField?.pricePerUnit?.toString()?.split(".");
        let finalPrice = updatedField?.pricePerUnit || "0";
        if (priceSplit?.length > 1) {
          if (priceSplit[1]?.length > 0) {
            finalPrice = priceSplit?.join(".");
          } else {
            finalPrice = priceSplit[0];
          }
        }
        const price = Number(finalPrice ?? 0);
        const qty = Number(updatedField?.quantity ?? 1);
        const gst = Number(updatedField?.gst ?? 0);

        let amount = price * qty;
        amount = parseFloat(
          (Math.round((amount + Number.EPSILON) * 100) / 100).toFixed(2)
        );

        const taxAmount = (price ?? 0) * qty * (gst ?? 0) * 0.01;

        // totalAmount += amount;
        // totalTaxAmount += parseFloat(taxAmount.toFixed(2));
        // grandTotal = parseFloat((totalAmount + totalTaxAmount).toFixed(2));
        updatedField.amount = (amount + taxAmount).toFixed(2);
        updatedField.finalUnitPrice = price;
        return updatedField;
      };

      if (name === "gst" || name === "pricePerUnit" || name === "quantity") {
        removeOldItemValues();

        let decimals =
          DECIMAL_BOARD[prevData?.items?.[index]?.["quantityUOM"] ?? "REST"];
        let num = value?.toString()?.split(".") || ["0"];
        if (!decimals) {
          decimals = 2;
        }
        // console.log("Number :: ", prevData?.items?.[index]?.[name]?.toString()?.split("."));
        if (
          num?.length > 2 ||
          num[0].length > 6 ||
          num[1]?.length > decimals ||
          (num[1]?.length > 0 && isNaN(num[1])) ||
          (num[0]?.length > 0 && isNaN(num[0]))
        ) {
          num = prevData?.items?.[index]?.[name]?.toString()?.split(".");
        }

        let newValue = num?.join(".");
        const updatedField = {
          ...currentItem,
          [name]: newValue,
        };

        updatedItems[index] = recalculateAndUpdateItem(updatedField);
      } else {
        updatedItems[index] = {
          ...currentItem,
          [name]: value,
        };
      }

      // totalAmount = parseFloat(
      //   (Math.round((totalAmount + Number.EPSILON) * 100) / 100).toFixed(2)
      // );
      // totalTaxAmount = parseFloat(
      //   (Math.round((totalTaxAmount + Number.EPSILON) * 100) / 100).toFixed(2)
      // );
      // grandTotal = parseFloat(
      //   (Math.round((grandTotal + Number.EPSILON) * 100) / 100).toFixed(2)
      // );

      return {
        ...prevData,
        items: updatedItems,
        // totalAmount: totalAmount,
        // grandTotal: grandTotal,
        // totalTaxAmount: totalTaxAmount,
      };
    });
  };

  // useEffect(() => {
  //   // console.log(adjustments)
  //   // console.log(orderHeaderData)
  //   // let totalAdjustment = 0;
  //   // let totalAdjustmentTax = 0;
  //   // let grandAdjustedAmount = 0;
  //   // adjustments?.forEach((adjustment: any) => {
  //   //   grandAdjustedAmount += Number(adjustment?.adjustmentTotal ?? 0);
  //   //   totalAdjustmentTax += Number(adjustment?.adjustmentTax);
  //   //   totalAdjustment += Number(adjustment?.adjustmentAmount ?? 0);
  //   // });
  //   // setAdjustmentValues({
  //   //   grandAdjustedAmount: grandAdjustedAmount,
  //   //   totalAdjustmentTax: totalAdjustmentTax,
  //   //   totalAdjustedAmount: totalAdjustment,
  //   // });
  // }, [adjustments]);

  const handleDeleteItemRow = (index: number) => {
    setOrderHeadData((prevData: any) => {
      const updatedItems = [...(prevData.items || [])];
      updatedItems.splice(index, 1);

      // let totalAmount = 0;
      // let totalTaxAmount = 0;
      // let grandTotal = 0;

      updatedItems.forEach((item: any) => {
        const quantity = parseFloat(item.quantity ?? 0);
        const unitPrice = parseFloat(item.pricePerUnit ?? 0);
        const gst = parseFloat(item.gst ?? 0);

        const itemBaseAmount = unitPrice * quantity;
        const itemTaxAmount = itemBaseAmount * gst * 0.01;
        const itemFinalAmount = itemBaseAmount + itemTaxAmount;

        // totalAmount += itemBaseAmount;
        // totalTaxAmount += itemTaxAmount;
        // grandTotal += itemFinalAmount;
      });

      // // Round to two decimal places
      // totalAmount = parseFloat(totalAmount.toFixed(2));
      // totalTaxAmount = parseFloat(totalTaxAmount.toFixed(2));
      // grandTotal = parseFloat(grandTotal.toFixed(2));

      return {
        ...prevData,
        items: updatedItems,
        // totalAmount,
        // totalTaxAmount,
        // grandTotal,
      };
    });
  };

  const addAdjustments = (newAdjustments: any) => {
    // console.log(newAdjustments)
    setAdjustments([...newAdjustments]);
    // setOpenDiscounts(false);
  };

  return (
    <Box className="order-input-table">
      <Stack px={6}>
        <Typography
          variant="h6"
          sx={{
            color: "black",
          }}
        >
          Contract details
        </Typography>
      </Stack>
      <TableContainer
        className="order-table"
        sx={{
          py: 2,
        }}
      >
        <Table sx={{ minWidth: 1400 }}>
          <TableHead>
            <TableRow>
              <TableCell
                width="15%"
                // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_NAME.label}
              </TableCell>
              <TableCell
                width="12%"
                // // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_HSN_CODE.label}
              </TableCell>
              <TableCell
                width="10%"
                // colSpan={2}
                className="tableCell"
              >
                {
                  ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_BRAND_NAME
                    .label
                }
              </TableCell>
              <TableCell
                width="10%"
                // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_SIZE.label}
              </TableCell>
              {/* <TableCell
                width="5%"
                // colSpan={2}
                className="tableCell"
              >
                {
                  ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_QUANTITY_UOM
                    .label
                }
              </TableCell>
              <TableCell
                width="10%"
                // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_QUANTITY.label}
              </TableCell> */}
              <TableCell
                width="15%"
                // colSpan={2}
                className="tableCell"
              >
                {
                  ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_UNIT_PRICE
                    .label
                }
              </TableCell>
              <TableCell
                width="5%"
                // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_GST.label}
              </TableCell>
              <TableCell
                width="15%"
                // colSpan={2}
                className="tableCell"
              >
                {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_AMOUNT.label}
              </TableCell>

              <TableCell width="3%" />
            </TableRow>
          </TableHead>
          <TableBody>
            {orderHeaderData?.items?.map((item: any, index: number) => {
              if (item.status && item.status == ITEM_STATUS.REJECTED) {
                return "";
              } else {
                return (
                  <TableRow sx={{ alignContent: "flex-start" }}>
                    <TableCell
                      // width='20%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>
                        {orderHeaderData?.items[index]?.item}
                      </Typography> */}
                      <TextField
                        className="item"
                        fullWidth
                        // disabled={true}
                        placeholder={ORDER_INPUT_TABLE_ROW?.item?.placeholder}
                        size="small"
                        value={orderHeaderData?.items[index]?.item}
                        onChange={(event: any) => {
                          handleItemNameChange(event, index);
                        }}
                        onFocus={(event: any) => {
                          setActiveItemNameIndex(index);
                          setFilteredProducts([]);
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`item_${index}`]}
                      />
                      {orderHeaderData?.items[index]?.item &&
                        activeItemNameIndex === index && (
                          <Paper className="options-list">
                            {filteredProducts?.length > 0 &&
                              filteredProducts?.map(
                                (product: any, ind: number) => (
                                  <MenuItem
                                    key={ind}
                                    onClick={() =>
                                      handleSelectItem(product, index)
                                    }
                                  >
                                    {product.productName +
                                      " | " +
                                      product.brandName}
                                  </MenuItem>
                                )
                              )}
                          </Paper>
                        )}
                      <FormHelperText
                        error={validationErrors?.[`item_${index}`]}
                      >
                        {validationErrors?.[`item_${index}`]}
                      </FormHelperText>
                    </TableCell>
                    <TableCell
                      // width='10%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>
                        {orderHeaderData?.items[index]?.hsnCode}
                      </Typography> */}
                      <TextField
                        fullWidth
                        placeholder={ORDER_INPUT_TABLE_ROW.hsn?.placeholder}
                        // disabled={true}
                        size="small"
                        value={orderHeaderData?.items[index]?.hsnCode}
                        onChange={(event: any) => {
                          handleInputChange(
                            index,
                            "hsnCode",
                            event?.target?.value,
                            `hsnCode_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`hsnCode_${index}`]}
                      />
                      <FormHelperText
                        error={validationErrors?.[`hsnCode_${index}`]}
                      >
                        {validationErrors?.[`hsnCode_${index}`]}
                      </FormHelperText>
                    </TableCell>

                    <TableCell
                      // width='15%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>
                        {orderHeaderData?.items[index]?.brandName}
                      </Typography> */}
                      <TextField
                        fullWidth
                        placeholder={
                          ORDER_INPUT_TABLE_ROW?.brandName?.placeholder
                        }
                        // disabled={true}
                        size="small"
                        value={orderHeaderData?.items[index]?.brandName}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          handleInputChange(
                            index,
                            "brandName",
                            event?.target?.value,
                            `brandName_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        // disabled={orderHeaderData?.items[index]?.productId ? true : false}
                        error={validationErrors?.[`brandName_${index}`]}
                      />
                      <FormHelperText
                        error={validationErrors?.[`brandName_${index}`]}
                      >
                        {validationErrors?.[`brandName_${index}`]}
                      </FormHelperText>
                    </TableCell>

                    <TableCell
                      // width='15%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>{item?.size}</Typography> */}
                      <TextField
                        fullWidth
                        // disabled={true}
                        placeholder={
                          ORDER_INPUT_TABLE_ROW?.itemSize?.placeholder
                        }
                        size="small"
                        value={item?.size}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          handleInputChange(
                            index,
                            "size",
                            event?.target?.value,
                            `size_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`size_${index}`]}
                      />
                      <FormHelperText
                        error={validationErrors?.[`size_${index}`]}
                      >
                        {validationErrors?.[`size_${index}`]}
                      </FormHelperText>
                    </TableCell>
                    {/* <TableCell
                      // width='7%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      <Select
                        fullWidth
                        size="small"
                        value={item?.quantityUOM || ""}
                        onChange={(event: any) => {
                          handleInputChange(
                            index,
                            "quantityUOM",
                            event?.target?.value,
                            `quantityUOM_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`quantityUOM_${index}`]}
                        displayEmpty
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <p className="selectPlaceholder">
                                {
                                  ORDER_INPUT_TABLE_ROW?.quantityUOM
                                    ?.placeholder
                                }
                              </p>
                            );
                          }
                          const selectedUOM = ITEM_UOMs?.find(
                            (uom: any) => uom._id === selected
                          );
                          return selectedUOM?.name || selected;
                        }}
                      >
                        {ITEM_UOMs?.map((uomItem: any) => (
                          <MenuItem key={uomItem?._id} value={uomItem?._id}>
                            {uomItem?.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText
                        error={validationErrors?.[`quantityUOM_${index}`]}
                      >
                        {validationErrors?.[`quantityUOM_${index}`]}
                      </FormHelperText>
                    </TableCell> */}

                    {/* <TableCell
                      // width='12%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      <TextField
                        fullWidth
                        placeholder={
                          ORDER_INPUT_TABLE_ROW?.quantity?.placeholder
                        }
                        size="small"
                        value={item?.quantity}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          handleInputChange(
                            index,
                            "quantity",
                            event?.target?.value,
                            `quantity_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`quantity_${index}`]}
                      />
                      <FormHelperText
                        error={validationErrors?.[`quantity_${index}`]}
                      >
                        {validationErrors?.[`quantity_${index}`]}
                      </FormHelperText>
                    </TableCell> */}
                    <TableCell
                      // width='12%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography>{item?.pricePerUnit}</Typography> */}
                      <TextField
                        fullWidth
                        // disabled={true}
                        placeholder={
                          ORDER_INPUT_TABLE_ROW.unitPrice?.placeholder
                        }
                        size="small"
                        value={item?.pricePerUnit}
                        onChange={(event: any) => {
                          handleInputChange(
                            index,
                            "pricePerUnit",
                            event?.target?.value,
                            `pricePerUnit_${index}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`pricePerUnit_${index}`]}
                      />
                      <FormHelperText
                        error={validationErrors?.[`pricePerUnit_${index}`]}
                      >
                        {validationErrors?.[`pricePerUnit_${index}`]}
                      </FormHelperText>
                    </TableCell>
                    <TableCell
                      // width='10%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>{item?.gst}</Typography> */}
                      <Select
                        fullWidth
                        // disabled={true}
                        size="small"
                        value={item?.gst}
                        onChange={(event: any) => {
                          handleInputChange(
                            index,
                            "gst",
                            event?.target?.value,
                            `gst_${index + 1}`
                          );
                        }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                        error={validationErrors?.[`gst_${index + 1}`]}
                        displayEmpty
                        renderValue={(selected: any) => {
                          if (
                            selected < 0 ||
                            selected === undefined ||
                            selected === null
                          ) {
                            return (
                              <p className="selectPlaceholder">
                                {
                                  ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS
                                    .ITEM_GST.placeholder
                                }
                              </p>
                            );
                          }
                          return selected;
                        }}
                      >
                        {ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_GST.values?.map(
                          (item: any) => (
                            <MenuItem value={item} sx={{ textAlign: "center" }}>
                              {item}
                            </MenuItem>
                          )
                        )}
                      </Select>
                      <FormHelperText
                        error={validationErrors?.[`gst_${index + 1}`]}
                      >
                        {validationErrors?.[`gst_${index + 1}`]}
                      </FormHelperText>
                    </TableCell>
                    <TableCell
                      // width='25%'
                      // colSpan={2}
                      className="tableCell"
                    >
                      {/* <Typography fontWeight={400}>
                        {!Number.isNaN(Number(item?.amount))
                          ? Number(item?.amount)?.toFixed(2)
                          : 0}
                      </Typography> */}
                      <TextField
                        fullWidth
                        // disabled={true}
                        placeholder={
                          ORDER_WIZARD_ITEMS.ORDER_TABLE_HEAD_ITEMS.ITEM_AMOUNT
                            .placeholder
                        }
                        size="small"
                        value={
                          !Number.isNaN(Number(item?.amount))
                            ? Number(item?.amount)?.toFixed(2)
                            : 0
                        }
                        InputProps={{ readOnly: true }}
                        sx={{
                          backgroundColor: "#f6f6f6",
                          "& input::placeholder": {
                            fontSize: "0.8rem",
                          },
                        }}
                      />
                    </TableCell>

                    <TableCell
                      // width='5%'
                      // colSpan={1}
                      className="tableCell"
                      // sx={{
                      //     display: "flex",
                      //     alignItems: "center",
                      //     justifyContent: "center"
                      // }}
                    >
                      <Stack
                        direction={"row"}
                        p={1}
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"center"}
                      >
                        <IconButton
                          sx={{ color: "#ED1B24" }}
                          onClick={() => handleDeleteItemRow(index)}
                        >
                          <DeleteCustom />
                        </IconButton>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              }
            })}
          </TableBody>
        </Table>
        <Box sx={{
                    mx: 4,
                    mt: 2,
                }}>
                    <FormHelperText error={validationErrors?.itemsDiv}>
                        {validationErrors?.itemsDiv}
                    </FormHelperText>
                    <Button
                        onClick={handleAddOrderRow}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 0,
                        }}
                    >
                        <AddBoxOutlined sx={{ color: "#22438C" }} />
                        <Typography color={"#22438C"}>Add more</Typography>
                    </Button>
                </Box>
        {/* <Box className="finalAmount-box">
          {adjustments &&
            adjustments?.length > 0 &&
            !isNaN(Number(adjustmentValues.totalAdjustedAmount)) &&
            Number(adjustmentValues.totalAdjustedAmount) > 0 && (
              <>
                <Box>
                  <Typography className="label">Subtotal:</Typography>
                  <Typography className="value">
                    ₹
                    {!Number.isNaN(Number(orderHeaderData?.totalAmount))
                      ? Number(orderHeaderData?.totalAmount ?? 0).toFixed(2)
                      : "0.00"}
                  </Typography>
                </Box>

                {adjustments.map((adjustment: any, index: number) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "right", mb: 1 }}
                  >
                    <Typography
                      className="label"
                      sx={{ whiteSpace: "nowrap", mr: 22 }}
                    >
                      {adjustment?.description || `Adjustment ${index + 1}`}:
                    </Typography>
                    <Typography className="value">
                      ₹
                      {!Number.isNaN(Number(adjustment?.adjustmentAmount))
                        ? Number(adjustment?.adjustmentAmount ?? 0).toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                ))}
                {adjustments && adjustments?.length > 1 && (
                  <Box>
                    <Typography className="label">
                      Total Amount (Adjusted):
                    </Typography>
                    <Typography className="value">
                      ₹
                      {!Number.isNaN(
                        Number(adjustmentValues?.totalAdjustedAmount)
                      )
                        ? Number(
                            adjustmentValues?.totalAdjustedAmount ?? 0
                          ).toFixed(2)
                        : "0.00"}
                    </Typography>
                  </Box>
                )}
              </>
            )}
          <Box>
            <Typography className="label">
              {!isNaN(Number(adjustmentValues?.totalAdjustedAmount)) &&
              Number(adjustmentValues?.totalAdjustedAmount) > 0
                ? "Gross Total:"
                : "Subtotal:"}
            </Typography>
            <Typography className="value">
              {!isNaN(Number(adjustmentValues?.totalAdjustedAmount)) &&
              Number(adjustmentValues?.totalAdjustedAmount) > 0
                ? `₹${
                    !Number.isNaN(Number(adjustmentValues?.totalAdjustedAmount))
                      ? (
                          Number(orderHeaderData?.totalAmount) -
                          Number(adjustmentValues?.totalAdjustedAmount ?? 0)
                        ).toFixed(2)
                      : "0.00"
                  }`
                : `₹${
                    !Number.isNaN(Number(orderHeaderData?.totalAmount))
                      ? Number(orderHeaderData?.totalAmount).toFixed(2)
                      : "0.00"
                  }`}
            </Typography>
          </Box>
          {
                        adjustments?.map((adjustment, index)=>{
                            return (
                                <Box key={index}>
                                    <Typography className="label">
                                        {adjustment?.description}
                                    </Typography>
                                    <Typography className="value">
                                        {`-₹${adjustment?.adjustmentAmount}`}
                                    </Typography>
                                </Box>
                            )
                        })
                    }
          <Box>
            <Typography className="label">Tax:</Typography>
            <Typography className="value">
              {adjustmentValues?.totalAdjustmentTax
                ? `₹${
                    !Number.isNaN(
                      BigNumber(orderHeaderData?.totalTaxAmount)
                        .minus(
                          BigNumber(adjustmentValues?.totalAdjustmentTax ?? 0)
                        )
                        .toNumber()
                    )
                      ? BigNumber(orderHeaderData?.totalTaxAmount)
                          .minus(
                            BigNumber(adjustmentValues?.totalAdjustmentTax)
                          )
                          .toNumber()
                          ?.toFixed(2)
                      : 0
                  }`
                : `₹${
                    !Number.isNaN(Number(orderHeaderData?.totalTaxAmount))
                      ? Number(orderHeaderData?.totalTaxAmount)?.toFixed(2)
                      : 0
                  }`}
            </Typography>
          </Box>
          <Box>
            <Typography className="label">Total Amount:</Typography>
            <Typography className="value">
              {adjustmentValues?.grandAdjustedAmount
                ? `₹${
                    !Number.isNaN(
                      BigNumber(orderHeaderData?.grandTotal)
                        .minus(
                          BigNumber(adjustmentValues?.grandAdjustedAmount ?? 0)
                        )
                        .toNumber()
                    )
                      ? BigNumber(orderHeaderData?.grandTotal)
                          .minus(
                            BigNumber(adjustmentValues?.grandAdjustedAmount)
                          )
                          .toNumber()
                          ?.toFixed(2)
                      : 0
                  }`
                : `₹${
                    !Number.isNaN(Number(orderHeaderData?.grandTotal))
                      ? Number(orderHeaderData?.grandTotal)?.toFixed(2)
                      : 0
                  }`}
            </Typography>
          </Box>
          <Button
                        onClick={()=>setOpenDiscounts(true)}
                        sx={{
                            textTransform: 'none',
                            borderRadius: 0,
                        }}
                    >
                        <AddBoxOutlined sx={{color: "#22438C"}} />
                        <Typography color={"#22438C"}>Add Discounts</Typography>
                    </Button>
        </Box> */}

        <Box
          sx={{
            mx: 4,
            mt: 2,
          }}
        >
          <FormHelperText error={validationErrors?.items_div}>
            {validationErrors?.items_div}
          </FormHelperText>
        </Box>
      </TableContainer>
      {/* <AdjustmentDialog open={openDiscounts} prevAdjustments={adjustments} onConfirm={addAdjustments} setOpen={setOpenDiscounts} /> */}
    </Box>
  );
};

export default RateContractInputTable;
